import React from 'react';
import { usePrintingColorChoice } from 'components/quote_builder_widget/shared/BasePrintingColorChooser';

const PrintingColorChooser = ({ widgetIdentifier, cartonMaterialUserPriceId }) => {
  const { ready, hasChoices, selectedKey, onChange, options, hiddenFields } = usePrintingColorChoice(widgetIdentifier, cartonMaterialUserPriceId);

  if (!ready) {
    return null;
  }

  if (!hasChoices) {
    return hiddenFields;
  }

  return (
    <div className="mb-3" data-widget-element="form-group">
      <div className="input-group">
        <span className="input-group-text font13" data-widget-element="label">
          {t('quote_builder.printing')}
        </span>
        <select
          value={selectedKey}
          onChange={onChange}
          className="form-select form-control text-align-right"
          data-widget-element="select"
        >
          {options}
        </select>
      </div>
      {hiddenFields}
    </div>
  );
};

export default PrintingColorChooser;
